.fd{border:1px solid #ddd;}